import React, { useContext } from "react";
import { AddOutlined } from "@material-ui/icons";

import { InputCell, OutputCell } from "../forecast-table/styles";
import { MatchContext } from "../../context";
import { FORECAST_TABLE_PARAMS } from "../../constants";
import {
  prepareNumber,
  prepareSum,
} from "../../utils/prepare-table-average-data";

const AverageRowData = ({ handlePlusClick }) => {
  const { state } = useContext(MatchContext);

  return (
    <React.Fragment>
      <InputCell align="center">Avg.</InputCell>
      <OutputCell align="center">-</OutputCell>
      <InputCell align="center">
        {prepareSum(
          state.forecastTableRows,
          FORECAST_TABLE_PARAMS.numberOfDays
        )}
      </InputCell>
      <InputCell align="center">
        {prepareNumber(state.forecastTableRows, FORECAST_TABLE_PARAMS.Zn_Fd)}
      </InputCell>
      <InputCell align="center">
        {prepareNumber(state.forecastTableRows, FORECAST_TABLE_PARAMS.Pb_Fd)}
      </InputCell>
      <OutputCell align="center">
        {prepareNumber(state.forecastTableRows, FORECAST_TABLE_PARAMS.Zn_Rec)}
      </OutputCell>
      <OutputCell align="center">
        {prepareNumber(state.forecastTableRows, FORECAST_TABLE_PARAMS.Zn_Gr)}
      </OutputCell>
      <OutputCell align="center">
        {prepareNumber(state.forecastTableRows, FORECAST_TABLE_PARAMS.Pb_Rec)}
      </OutputCell>
      <OutputCell align="center">
        {prepareNumber(state.forecastTableRows, FORECAST_TABLE_PARAMS.Pb_Gr)}
      </OutputCell>
      <InputCell align="center">
        {prepareNumber(state.forecastTableRows, FORECAST_TABLE_PARAMS.TPOH)}
      </InputCell>
      <InputCell>
        <i className="material-icon">
          <AddOutlined onClick={handlePlusClick} />
        </i>
      </InputCell>
    </React.Fragment>
  );
};

export default AverageRowData;
